import Axios from "axios";

export default {
  // getAllBroker() {
  //   return Axios.get("/catalogs/getAllBroker");
  // },
  getAllBroker() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Aps");
  },

  getAllGenders() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Genero");
  },

  getAllCivilStatus() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=EstadoCivil");
  },

  getProvinces() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Provincias");
  },

  getAllCanton() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Canton");
  },
  getAllGestorFvc() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=GestorFvc");
  },
  getAllParroquia() {
    return Axios.get("https://www.aseguradoradelsur.com.ec/asurApiCatalogosTesting/api/catalogo/parroquia/v1")
  },
  getAllCities() {
    return Axios.get("https://www.aseguradoradelsur.com.ec/asurApiCatalogosTesting/api/catalogo/ciudad/v1")
  },
  getCantonByProvince(province) {
    return Axios.get("/catalogs/getCantonByProvince?provinceCode=" + province);
  },
  getCityByProvince(province){
    return Axios.get("catalogs/getCityByProvince?provinceCode=" + province);
  },
  getAllNacionalities(){
    return Axios.get("catalogs/getAllNationalities");
  },
  getAllVehicleBrands() {
    return Axios.get("/catalogs/getAllVehicleBrands");
  },

  getAllVehicleModels() {
    return Axios.get("/catalogs/marcas/v1");
  },

  getAllPaymentMethodByGrouper() {
    let url = "/catalogs/getAllBpmCatalogsByName?catalogName=FormaPago";
   
    return Axios.get(url);
  },

  getAllPaymentMethodByPersonType(personType) {
    let url = "/catalogs/getAllPaymentMethodByPersonType";
    if (personType) {
      url += "?personType=" + personType;
    }
    return Axios.get(url);
  },

  getQuota() {
    let url = "/catalogs/getAllBpmCatalogsByName?catalogName=Cuota";
    return Axios.get(url);
  },

  getAllPaymentMethodRamo() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Ramo");
  },

  getAllTypeCoverage() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=TipoCobertura");
  },

  getAllAutototalGroupers() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Agrupador");
  },
  getCatalogsDesicion(){
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Desicion");
  },

  getAllTypesIdentification() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=TipoIdentificacion");
  },

  getAllTypesPerson() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=TipoPersona");
  },
  getAllRamosToEmit() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Ramo");
  },

  getAllProduct() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=Producto");
  },
  getAllTipeEmisionToEmit(){
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=TipoEmision");

  },
  getAllTypeMovements() {
    return Axios.get("/catalogs/getAllBpmCatalogsByName?catalogName=TipoEndoso");
  },
  getPolicyDetail(numPolicy, identification) {
    return Axios.get("/catalogs/getPolicyDetail?numPolicy=" + numPolicy + "&identification=" + identification);
  },
  getTypeOfProduction() {
    return Axios.get("/catalogs/getTypeOfProduction");

  },
  getTypeLineBusiness() {
    return Axios.get("/catalogs/getLineBusinessByYear?year=2022");

  },
  getLineBusinessByYear() {
    return Axios.get("/catalogs/getLineBusinessByYear?year=2023");

  },
  getIndicators() {
    return Axios.get("/catalogs/getIndicators");

  },
  getDataApsInfo() {
    let url = "/catalogs/getApsInfo";
    return Axios.get(url);

  }
  

};